import React from "react";
import { useParams } from "react-router-dom";
import EvacuationActive from "@/pages/EvacuationActive";

/**
 * Public warden landing page — uses warden token from URL, never reads admin localStorage.
 * Reuses the EvacuationActive component but with token override.
 */
export default function EvacuationWarden() {
  const { token } = useParams();
  return <EvacuationActive wardenToken={token} />;
}
